// extracted by mini-css-extract-plugin
module.exports = {"welcomeElementWrapperMobile":"MobileNotSupportedError_welcomeElementWrapperMobile__mqW2R"};